import * as React from 'react';
export const UYSvg = React.forwardRef(function UYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4B32E',
      fillRule: 'evenodd',
      d: 'M3.5 6.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: '#43458B',
        clipPath: 'url(#fi_FlagIcon-UY__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6.66 3.333H16v1.333H6.66zM6.66 6H16v1.333H6.66zM0 8.667h16V10H0zm0 2.666h16v1.333H0z',
      }),
    ),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      fillOpacity: 0.1,
      fillRule: 'evenodd',
      d: 'M2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2ZM14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'fi_FlagIcon-UY__a',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: 16,
          height: 12,
          y: 2,
          fill: '#fff',
          rx: 2,
        }),
      ),
    ),
  );
});
UYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var UY = {
  category: 'flag',
  colorable: false,
  name: 'UY',
  svg: UYSvg,
};
